import { LocalStorage2FAKeys } from '@pkg/types';
import { removeLocalStorageItems } from '@pkg/utils';

import { handleRemoveAuthTokens } from '@app/store/zustand/auth/useAuthTokens';
import { handleClearWalletStore } from '@app/store/zustand/wallet/useWalletStore';

export function flushTokens(keepRefreshToken?: boolean) {
    handleRemoveAuthTokens({ keepRefreshToken });
    handleClearWalletStore();
    removeLocalStorageItems([LocalStorage2FAKeys.TimeSinceRequire, LocalStorage2FAKeys.TimeSincePostPurchase]);
}
